import React from 'react';
import { Shield, Zap, Globe, Award, CheckCircle } from 'lucide-react';
import './WhyCNTerminal.css';

const WhyCNTerminal: React.FC = () => {
  const features = [
    {
      icon: <Shield size={48} />,
      title: 'Licensed & Certified',
      description: 'Fully licensed Customs House Agency with all necessary certifications and regulatory compliance.'
    },
    {
      icon: <Zap size={48} />,
      title: 'Fast & Efficient',
      description: 'Streamlined processes ensure quick turnaround times without compromising on quality and safety.'
    },
    {
      icon: <Globe size={48} />,
      title: 'Global Network',
      description: 'Strategic partnerships with leading carriers and agents worldwide for seamless international shipping.'
    },
    {
      icon: <Award size={48} />,
      title: 'Proven Track Record',
      description: 'Years of successful operations with consistent growth and satisfied clients across industries.'
    }
  ];

  return (
    <section className="why-cn-terminal">
      <div className="container">
        <div className="why-content">
          <div className="why-header">
            <h2 className="why-title">Why Choose CN Terminal?</h2>
            <p className="why-subtitle">
              We are your trusted partner in logistics, providing comprehensive shipping and customs clearance 
              services with a commitment to excellence, reliability, and customer satisfaction.
            </p>
          </div>

          <div className="why-features-grid">
            {features.map((feature, index) => (
              <div key={index} className="why-feature-card">
                <div className="why-feature-icon">
                  {feature.icon}
                </div>
                <h3 className="why-feature-title">{feature.title}</h3>
                <p className="why-feature-description">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="why-highlights">
            <div className="why-highlight-item">
              <CheckCircle size={24} />
              <span>Licensed Customs House Agency</span>
            </div>
            <div className="why-highlight-item">
              <CheckCircle size={24} />
              <span>Global Partnerships & Network</span>
            </div>
            <div className="why-highlight-item">
              <CheckCircle size={24} />
              <span>Expert Team of Professionals</span>
            </div>
            <div className="why-highlight-item">
              <CheckCircle size={24} />
              <span>24/7 Customer Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCNTerminal;

